import { FeatureCollection, GeoJsonProperties, Geometry } from 'geojson';
import React from 'react';
import { Source, Layer, LayerProps } from 'react-map-gl';

interface BoundaryLayerProps {
  geoJson: FeatureCollection<Geometry, GeoJsonProperties>;
  sourceId: string;
}

const fillLayer: LayerProps = {
  id: 'county-fill',
  type: 'fill',
  paint: {
    'fill-color': '#F26B1D',
    'fill-opacity': 0.4,
  },
};

const outlineLayer: LayerProps = {
  id: 'county-outline',
  type: 'line',
  paint: {
    'line-color': '#D63F2F',
    'line-width': 1,
  },
};

export const BoundaryLayer = ({ geoJson, sourceId }: BoundaryLayerProps) => {
  return (
    <Source id={sourceId} type="geojson" data={geoJson}>
      <Layer {...fillLayer} />
      <Layer {...outlineLayer} />
    </Source>
  );
};
